import { render } from "./OsSolicitacaoStatusSelect.vue?vue&type=template&id=796a3919"
import script from "./OsSolicitacaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./OsSolicitacaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__